import React from 'react';
import classnames from 'classnames';

import TextComponent from 'shared/components/TextComponent';

const SmallestHoleSize = (props) => {
  const name = 'smallest_hole_size';
  const {
    label,
    inputId,
    parameters,
    onChangeParameter,
    groupName,
    required,
    tooltip,
    className,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name="smallest_hole_size"
      inputId={inputId}
      value={parameters[name] || ''}
      required={required}
      onChange={onChange}
      groupName={groupName}
      tooltip={tooltip}
      className={classnames('smallest-hole-size', className)}
      disabled={disabled}
      {...props} />
  );
};

SmallestHoleSize.defaultProps = {
  groupName: 'parameters',
  inputId: 'smallest_hole_size',
  tooltip: Spree.helpForParameters.smallest_hole_size,
  label: Spree.translations.parameters.smallest_hole_size,
  required: false,
};

export default SmallestHoleSize;
